import { render, staticRenderFns } from "./main.vue?vue&type=template&id=d06a5700&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"
import style0 from "./main.vue?vue&type=style&index=0&id=d06a5700&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d06a5700')) {
      api.createRecord('d06a5700', component.options)
    } else {
      api.reload('d06a5700', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=d06a5700&", function () {
      api.rerender('d06a5700', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DwCarousel/src/main.vue"
export default component.exports